/** Feature flag — set to true to re-enable the AI chat assistant */
export const ENABLE_AI_CHAT = false;
